import classNames from 'classnames'
import { withPrefix } from 'gatsby'
import React from 'react'
import * as Styles from './page-title.module.scss'

export function PageTitle({
  title,
  en,
  children,
  readText,
  decorationLogo,
  isChildHeight = true,
  ipo = false,
  ...props
}) {
  return (
    <div
      className={classNames(
        children && isChildHeight ? Styles.wrap__children : Styles.wrap,
        ipo && Styles.ipo,
        props.className
      )}
      style={{
        height: props.height,
      }}
    >
      <div className={Styles.pageTitle__bg} />
      <div className={Styles.pageTitle}>
        {en ? (
          <p className={classNames(Styles.pageTitle__en, 'sans-serif')}>{en}</p>
        ) : null}
        {title ? <h1 className={Styles.pageTitle__title}>{title}</h1> : null}
        {decorationLogo ? (
          <img
            src={withPrefix('/page-title_icon_logo.svg')}
            alt=""
            className={Styles.pageTitle_decoration_logo}
            width={751.43}
            height={737.03}
          />
        ) : null}
        {children}
        {readText ? <p className={Styles.readText}>{readText}</p> : null}
      </div>
    </div>
  )
}
